import { DeliveryMethodNames } from '@eo-storefronts/eo-core'
import { Box } from '@mui/material'
import InlineAddress from '~/src/components/customers/addresses/InlineAddress'
import Title from '~/src/components/mui-wrappers/Title'
import { useEoValue } from '~/src/hooks/useEoState'
import { useTranslations } from '~/src/hooks/useTranslations'
import { CHECKOUT_FORM_STATE } from '~/src/stores/checkout'

const CheckoutDeliveryAddress = () => {
  const checkoutForm = useEoValue(CHECKOUT_FORM_STATE)
  const { t } = useTranslations()

  if (
    checkoutForm.delivery_method.method !== DeliveryMethodNames.DELIVERY
    || !checkoutForm.delivery_method.address
  ) {
    return null
  }

  return (
    <Box>
      <Title>{t('checkout.delivery_address')}</Title>
      <Box sx={{
        display: 'inline-block',
        p: 1,
        my: 1,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'primary.main',
        borderRadius: 2,
        color: 'primary.main'
      }}>
        <InlineAddress address={checkoutForm.delivery_method.address} />
      </Box>
    </Box>
  )
}

export default CheckoutDeliveryAddress
